import { render, staticRenderFns } from "./ProjectsByMap.vue?vue&type=template&id=385a8d78&"
import script from "./ProjectsByMap.vue?vue&type=script&lang=js&"
export * from "./ProjectsByMap.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsByMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports